import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useForwardToEndorsingOffice = (
  isLoading,
  isStarted,
  transactionStatus,
  applicationStatus,
  isNew,
  hasBin,
  startAssessBy,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed =
    ['FOR CHECKING', 'COMPUTED'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['FOR PERMIT PROCESS'].indexOf(applicationStatus) > -1;

  const isAllowed =
    true &&
    startAssessBy &&
    isStatusAllowed &&
    isApplicationStatusAllowed &&
    isStarted;

  const isAllowedNew =
    true && isApplicationStatusAllowed && isStarted && hasBin;

  const showComponent = isNew === true ? isAllowedNew : isAllowed;

  const onStartAssessment = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to forward this application to Endorsing Office(s)?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onStartAssessment}
      type="button"
      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Forward to Endorsing Office
    </button>
  ) : null;

  return {
    isAllowed,
    onStartAssessment,
    component,
  };
};

export default useForwardToEndorsingOffice;
